import { Button, TextField, Box, Alert, Typography } from "@mui/material"
import { useState } from "react";
import CustomLoader from '../../../core/components/common/custom-loader.component';
import CustomFormSuccess from '../../../core/components/common/custom-form-success.component';
import PermissionService from "../services/api/permission-service";

const EditFunctionForm = ({row, handleClose, handleRecordChange}) => {
    const [functionName, setFunctionName] = useState(row.fn);
    const [description, setDescription] = useState(row.description);
    const [errorMessage, setErrorMessage] = useState();
    const [statusCode, setStatusCode] = useState();
    
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    
    const handleSubmit = () => {
        setLoading(true); 

        let paramaters = {
            'id': row.id
        }

        let payload = {
            fn: functionName,
            description: description
        }
        console.log(payload)
        let request = PermissionService.updatePermission(paramaters,payload);
        request.then((result) => {
            setLoading(false);
            let apiResponse = result.data;
            console.log("apiResponse", apiResponse)
            setSuccess(true)
            handleRecordChange();
        }).catch((error) => {
            console.log("error", error)
            setLoading(false);
            setSuccess(false)
            setStatusCode(error.status)
            const errorMessage = error?.response?.data?.error || error?.response?.data?.error_message;
            setErrorMessage(errorMessage)
        })
    }

    return (
        <div>
             {loading ? ( 
                <CustomLoader/>
            ) : (
                <div>
                    {success ? ( 
                        <CustomFormSuccess handleClose={handleClose}
                            message={"Function was successfully updated"}
                        />
                    ) : (
                    <div>
                        {errorMessage && (
                            <Alert style={{marginBottom: "12px"}} severity="error">
                                {errorMessage}.
                                <Typography sx={{ fontSize: '0.5rem' }}>
                                    Status Code: {statusCode}
                                </Typography>
                            </Alert>
                        )}
                         <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <TextField 
                                label="Function Name" 
                                variant="outlined" 
                                fullWidth
                                value={functionName} 
                                onChange={(e) => setFunctionName(e.target.value)}
                             />
                            <TextField
                                label="Description"
                                variant="outlined"
                                multiline
                                rows={4} 
                                fullWidth
                                value={description} 
                                onChange={(e) => setDescription(e.target.value)}
                            />
                            <Button type="button" variant="contained" sx={{ alignSelf: 'flex-end' }} onClick={handleSubmit}> Submit</Button>
                        </Box>
                    </div>

                )}
                </div>
            )}
           
        </div>
    )
}
export default EditFunctionForm